import { render } from "./logo.mini.vue?vue&type=template&id=2f5b3cf3"
import script from "./logo.mini.vue?vue&type=script&lang=js"
export * from "./logo.mini.vue?vue&type=script&lang=js"

import "./logo.mini.vue?vue&type=style&index=0&id=2f5b3cf3&lang=scss"

import exportComponent from "D:\\Development\\vue\\okraina.sbs.monitor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__